export function download(source: string | Blob, filename?: string): void {
  const element = document.createElement('a');

  element.style.display = 'none';
  if (typeof source === 'string') {
    element.href = source;
  } else {
    element.href = URL.createObjectURL(source);
  }

  if (filename) {
    element.setAttribute('download', filename);
  }

  // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof element.download === 'undefined') {
    element.setAttribute('target', '_blank');
  }

  document.body.appendChild(element);
  element.click();

  document.body.removeChild(element);
}
